import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, makeStyles } from "@material-ui/core";
import { ValidatorForm } from 'react-material-ui-form-validator';
import { NuevaSoilcStep3Terapia } from './NuevaSoilcStep3Terapia';
import { NuevaSoilcStep3Transporte } from './NuevaSoilcStep3Transporte';
import { STEPPER_INTEGRACION_AUTO_G, TIPO_SOLICITUD_INTEGRACION } from '../../../Discapacidad/data/constants';
import { postSolicitudDiscapacidadAutoG } from '../../../../actions/webAfiliado/afiliadoDiscapacidadActions';

const useStyles = makeStyles((theme) => ({
  buttons: {
    marginTop: "2rem",
    marginBottom: "1rem",
    display: "flex",
    justifyContent: "space-around"
  },
}));

export const NuevaSolicStep3 = ({ handleChangeStep}) => {
  const {  solicitudSeleccionada } = useSelector(state => state.afiliadoDiscapacidad)

  const classes = useStyles();
  const dispatch = useDispatch();

  const [haveChangeValues, setHaveChangeValues] = useState(false);
  
  const onSubmitHandler = () => {
    if (!haveChangeValues) {
      handleChangeStep(STEPPER_INTEGRACION_AUTO_G.DIAGNOSTICO_DOCUMENTACION);
    } else {
      dispatch(postSolicitudDiscapacidadAutoG(
        {...solicitudSeleccionada, datosComplemento: true, esAfiliado: true}, 
        STEPPER_INTEGRACION_AUTO_G.DIAGNOSTICO_DOCUMENTACION
        )
      );
    }
  };
  console.log(solicitudSeleccionada)
  return (
    <ValidatorForm onSubmit={onSubmitHandler} style={{ margin: "1rem 3rem" }}>
      {solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TRANSPORTE &&
        <NuevaSoilcStep3Transporte 
          setHaveChangeValues={setHaveChangeValues} 
          solicitudSeleccionada={solicitudSeleccionada} 
        />
      }
      {(solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TERAPIA_INDIVIDUAL ||
        solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TERAPIA_MODULO) &&
        <NuevaSoilcStep3Terapia 
          setHaveChangeValues={setHaveChangeValues}
          solicitudSeleccionada={solicitudSeleccionada} 
        />
      }        
      <div className={classes.buttons}>
        <Button
          type="button"
          variant="contained"
          color="secondary"
          style={{textTransform:"none"}}
          onClick={() => {
            handleChangeStep(STEPPER_INTEGRACION_AUTO_G.DETALLES_ORDEN);
          }}
        >
          Anterior
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          style={{textTransform:"none"}}
        >
          Siguiente
        </Button>
      </div>
    </ValidatorForm>
  );
};
